/**
 * Created by frank.law on 11/14/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import ResendVerificationLinkForm from '../forms/ResendVerificationLinkForm';
import UsernameForm from '../forms/UsernameForm';
import PasswordForm from '../forms/PasswordForm';
import AuthCodeForm from '../forms/AuthCodeForm';
import ScanCodeForm from '../forms/ScanCodeForm';
import SamlForm from '../forms/SamlForm';
import RegionForm from '../forms/RegionForm';
import PasswordConfirmationForm from '../forms/PasswordConfirmationForm';
import ResetPasswordConfirmation from '../forms/ResetPasswordConfirmation';
import MessageContainer from '../forms/MessageContainer';
import TotpBackupCodes from "../forms/TotpBackupCodes";
import StandardLoginRequestForm from "../forms/StandardLoginRequestForm";
import StandardLoginRegionForm from "../forms/StandardLoginRegionForm";
import PropTypes from 'prop-types';
import LoadingContainer from '../LoadingContainer';
import {redirectForCode, redirectForToken, redirectToUrl} from '../../actions/actions';
import env from '../../../env';
import Banner from '../Banner';
import AcknowledgementModal from "../AcknowledgmentModal";

class FormFieldContainer extends React.Component {

    constructor(props) {
        super(props);
        // Add a state to track if the user has agreed
        const isIL4Toggle = env.IS_IL4;
        this.state = {
            hasAgreed: isIL4Toggle !== "true", // Set to true if IL4 toggle is not enabled
        };
        this.handleAgree = this.handleAgree.bind(this);
    }

    // This method is called when the user clicks "I Agree"
    handleAgree() {
        this.setState({ hasAgreed: true });
    }

    render() {

        const {isLoading, challenge, authnRequest, redirectForCode, redirectForToken, redirectToUrl, redirectEndpoint, standardLoginRedirectUrl} = this.props;
        const { hasAgreed } = this.state;

        // Get the IL4 toggle directly here to make the rendering decision
        const isIL4Toggle = env.IS_IL4;
        // If the user has NOT yet agreed, render only the acknowledgement modal
        if (isIL4Toggle === "true" && !hasAgreed) {
            return <AcknowledgementModal onAgree={this.handleAgree} />;
        }

        let fieldForm = [];
        if (isLoading) {
            fieldForm.push((<LoadingContainer key="LoadingContainer_1" />));
        }
        else if (challenge === 'resend_link') {
            fieldForm.push((<ResendVerificationLinkForm key="ResendVerificationLinkForm_1"/>))
        }
        else if (challenge === 'reset_pass') {
            fieldForm.push((<PasswordConfirmationForm key="ConfirmPasswordForm_1" />));
        }
        else if (challenge === 'user' || challenge === 'tenant') {
            if (authnRequest !== '') {
                fieldForm.push((<SamlForm key="SamlForm_1"/>));
            }
            else if (redirectEndpoint !== '') {
                fieldForm.push((<RegionForm key="RegionForm_1"/>));
            }
            else {
                fieldForm.push((<UsernameForm key="UsernameForm_1"/>));
            }
        }
        else if (typeof challenge === "undefined" && authnRequest !== '') {
            fieldForm.push((<SamlForm key="SamlForm_1"/>));
        }
        else if (challenge === 'pass') {
            fieldForm.push((<PasswordForm key="PasswordForm_1"/>));
        }
        else if (challenge === 'totp_setup') {
            fieldForm.push((<ScanCodeForm key="ScanCodeForm_1"/>));
        }
        else if (challenge === 'totp_verify' || challenge === 'totp') {
            fieldForm.push((<AuthCodeForm key="AuthCodeForm_1" />));
        }
        else if (challenge === 'backup_codes') {
            fieldForm.push((<TotpBackupCodes key="TotpBackupCodes_1" />));
        }
        else if (challenge === 'reset_sent') {
            fieldForm.push((<ResetPasswordConfirmation key="ResetPasswordConfirmation_1" />));
        }
        else if (challenge === 'standard_login_request') {
            if (standardLoginRedirectUrl) {
                fieldForm.push((<StandardLoginRegionForm key="StandardLoginRegionForm_1" />));
            } else {
                fieldForm.push((<StandardLoginRequestForm key="StandardLoginRequestForm_1" />));
            }
        }
        else if (challenge === 'message') {
            fieldForm.push((<MessageContainer key="MessageContainer_1" />));
        }
        else if (challenge === 'complete') {
            const {responseType, targetUrl, state, code, accessToken, tokenType, regionName, platform} = this.props;
            if (responseType === 'code') {
                redirectForCode(targetUrl, state, code, regionName, platform);
            }
            else if (responseType === 'token') {
                redirectForToken(targetUrl, state, accessToken, tokenType, regionName, platform);
            }
            else if (responseType === 'blank') {
                redirectToUrl(targetUrl, state, regionName, platform);
            }
        }

        if (!isLoading && fieldForm.length > 0 && redirectEndpoint === '' && !standardLoginRedirectUrl) {
            fieldForm.push((<Banner />));
        }

        return (
            <div className="form-field-container">
                {fieldForm}
            </div>
        );
    }
}

FormFieldContainer.defaultProps = {
    authnRequest: '',
    redirectEndpoint: '',
    standardLoginRedirectUrl: ''
};

FormFieldContainer.propTypes = {
    isLoading: PropTypes.bool,
    challenge: PropTypes.string,
    responseType: PropTypes.string,
    targetUrl: PropTypes.string,
    state: PropTypes.string,
    code: PropTypes.string,
    accessToken: PropTypes.string,
    tokenType: PropTypes.string,
    authnRequest: PropTypes.string,
    redirectEndpoint: PropTypes.string,
    standardLoginRedirectUrl: PropTypes.string,
    regionName: PropTypes.string,
    platform: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        isLoading: state.login.isLoading,
        challenge: state.login.challengeResponse.nextChallenge,
        responseType: state.login.challengeResponse.responseType,
        targetUrl: state.login.challengeResponse.targetUrl,
        state: state.login.challengeResponse.state,
        code: state.login.challengeResponse.code,
        accessToken:  state.login.challengeResponse.accessToken,
        tokenType:  state.login.challengeResponse.tokenType,
        authnRequest:  state.login.authnRequest,
        redirectEndpoint:  state.login.redirectEndpoint,
        standardLoginRedirectUrl: state.login.standardLoginRedirectUrl,
        regionName:  state.login.challengeResponse.regionName,
        platform:  state.login.challengeResponse.platform
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        redirectForCode: (targetUrl, state, code, regionName, platform) => {
            dispatch(redirectForCode(targetUrl, state, code, regionName, platform));
        },
        redirectForToken: (targetUrl, state, accessToken, tokenType, regionName, platform) => {
            dispatch(redirectForToken(targetUrl, state, accessToken, tokenType, regionName, platform));
        },
        redirectToUrl: (targetUrl, state, regionName, platform) => {
            dispatch(redirectToUrl(targetUrl, state, regionName, platform))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FormFieldContainer);
